<template>
	<!-- 评审组 -->
	<div class="review">
		<div class="subject-group" v-show="!addOrDelTopicDialogVisible">
			<!-- 添加组按钮 -->
			<div class="clearfix">
				<div class="conditionRight">
					<div class="fc-button-group">
						<button v-if="flow < 5" type="button" class="btn btn-primary ml-1" @click="openAddGroupDialog('add', false)">
							<i class="dripicons-plus mr-1"></i>
							<span>增加组</span>
						</button>
					</div>
				</div>
			</div>
			<!-- 分组表格 -->
			<table id="ktfz-datatable" class="table table-hover table-bordered table-centered table-proApp">
				<thead>
					<tr>
						<th class="text-center">评审组名称</th>
						<th class="text-center">待评作品数</th>
						<th class="text-center">设置</th>
						<th class="text-center">操作</th>
					</tr>
				</thead>
				<tbody v-if="groupList.length">
					<tr v-for="(item, index) in groupList" :key="index">
						<td class="text-center">{{ item.name }}</td>
						<td class="text-center">{{ item.num }}</td>
						<td class="text-center">
							<span class="ml-1 mr-1" v-if="flow < 5" data-toggle="modal" data-target="#addTopic" @click="openAddTopicDialog('add', item)">添加作品</span>
							<span class="ml-1 mr-1" v-if="flow < 5" data-toggle="modal" data-target="#remTopic" @click="openAddTopicDialog('del', item)">移除作品</span>
							<span class="ml-1 mr-1" @click="openAddTopicDialog('view', item)">查看</span>
						</td>
						<td class="text-center">
							<span v-if="flow < 5" class="ml-1 mr-1" data-toggle="modal" data-target="#groupName" @click="openAddGroupDialog('update', item)">修改组名</span>
							<el-popconfirm title="确定删除该组吗？" @confirm="handleDelGroup(item)">
								<span v-if="flow < 5" class="ml-1 mr-1" slot="reference">删除组</span>
							</el-popconfirm>
						</td>
					</tr>
				</tbody>
			</table>
			<!-- 保存并下一步 -->
			<div class="text-center"><button type="button" v-if="flow < 5" class="btn btn-info" @click="submitGroupForm">保存并下一步</button></div>
		</div>

		<!-- 添加评审，修改组名 -->
		<el-dialog title="添加评审组" width="30%" :visible.sync="groupNameDialogShow" :close-on-click-modal="false" @close="cancelUpdateGroup">
			<el-form :model="addGroupForm" ref="addGroupFormRef" :rules="addGroupFormRules" label-width="max-content">
				<el-form-item label="组名称：" prop="name"><el-input style="width: 300px;" v-model.trim="addGroupForm.name"></el-input></el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelUpdateGroup">取 消</el-button>
				<el-button type="primary" @click="addOrEditGroup">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 添加，查看作品 -->
		<div class="topic_list" v-show="addOrDelTopicDialogVisible">
			<!-- <div class="topic_list_title">{{ `${addOrDelTopicDialogTitle}（当前组别：${modifiedData.name}）` }}</div> -->

			<el-form :inline="true" ref="addTopicDialogFilterFormRef" :model="addTopicDialogForm" label-width="80px">
				<el-form-item label="作品名称"><el-input size="mini" v-model="addTopicDialogForm.title"></el-input></el-form-item>
				<el-form-item label="学段">
					<el-select size="mini" v-model="addTopicDialogForm.learningSection" clearable placeholder="请选择">
						<el-option v-for="item in learingTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="学科">
					<el-select size="mini" v-model="addTopicDialogForm.disciplineId" clearable placeholder="请选择">
						<el-option v-for="item in disciplineOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="作者"><el-input size="mini" v-model="addTopicDialogForm.author"></el-input></el-form-item>
				<el-form-item label="单位"><el-input size="mini" v-model="addTopicDialogForm.unit"></el-input></el-form-item>
				<el-form-item label=" " label-width="0px"><el-button type="primary" size="mini" @click="solicitateList">查询</el-button></el-form-item>
			</el-form>

			<!-- 表格 -->
			<el-table
				:header-cell-style="tableStyle"
				v-loading="isTabelLoading"
				border
				ref="table2"
				:data="topicList"
				tooltip-effect="dark"
				style="width: 100%"
				@selection-change="mulSelectionChange"
				row-key="id"
			>
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column prop="title" label="名称" width="450"></el-table-column>
				<el-table-column prop="learningSectionString" label="学段" width="100"></el-table-column>
				<el-table-column prop="disciplineIdString" label="学科" width="100"></el-table-column>
				<el-table-column prop="unit" label="所属单位"></el-table-column>
				<el-table-column prop="author" label="作者">
					<template slot-scope="scope">
						{{ scope.row.author }},{{ scope.row.record }}
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				style="text-align: center; margin-top: 10px"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="addTopicDialogForm.pageNumber"
				:page-sizes="[50, 100, 200]"
				:page-size="addTopicDialogForm.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="topicTotal"
			></el-pagination>
			<div class="btn_wrap">
				<el-button @click="addOrDelTopicDialogVisible = false">返 回</el-button>
				<!-- @click="addTopicToGroup" -->
				<el-button type="primary" v-if="addOrDelTopicDialogTitle !== '查看作品'" @click="submitBtn(addOrDelTopicDialogTitle)">{{ addOrDelTopicDialogTitle }}</el-button>
			</div>
		</div>
	</div>
</template>

<script>
import { addSettingGroup, settingGroup, delSettingGroup, getPageListReview, getReviewInfo } from '@/api/after/newInterface.js';
import { getPlatformInformationData } from '@/api/after/systemManagement.js';
export default {
	data() {
		return {
			tableStyle: {
				textAlign: 'center',
				backgroundColor: '#7e9be2',
				color: '#fff'
			},
			addOrDelTopicDialogVisible: false,
			groupNameDialogShow: false,
			groupList: [],
			reviewState: 1,
			review: null,
			addGroupForm: {
				name: ''
			},
			addGroupFormRules: {
				name: [{ required: true, message: '请输入分组名称！', trigger: 'blur' }]
			},
			// 添加课题到分组-获取课题列表
			addTopicDialogForm: {
				pageNumber: 1,
				pageSize: 20,
				projectId: '',
				title: '',
				grade: 0,
				grade: null,
				state: 4
			},
			topicTotal: 10,
			topicList: [],
			modifiedData: null, //正在被操作的分组数据
			curOperate: 'add',
			// 多选课题
			mulSelectVal: [],
			isTabelLoading: false,
			addOrDelTopicDialogTitle: '添加到评审组',
			disciplineOptions: [], //学科
			learingTypeOptions: [
				{
					value: '0',
					label: '幼儿园'
				},
				{
					value: '1',
					label: '小学'
				},
				{
					value: '2',
					label: '初中'
				},
				{
					value: '3',
					label: '高中'
				},
				{
					value: '4',
					label: '高/中职'
				},
				{
					value: '5',
					label: '其他'
				}
			], //学段
			projectId: null,
			rowId: '',
			workId: '',
			isSelect: [],
			flow: null
		};
	},
	filters: {
		getTopicNum(val) {
			if (val) {
				return val.split(',').length;
			}
		}
	},
	mounted() {
		this.projectId = sessionStorage.getItem('projectId');
		this.addTopicDialogForm.projectId = this.projectId;
		this.getState();
		this.getSettingGroup();
		this.getDiscipline();
	},
	methods: {
		getState() {
			getReviewInfo(this.projectId).then(res => {
				this.flow = res.data.flow;
			});
		},
		// 获取学科
		async getDiscipline() {
			const res = await getPlatformInformationData(13);
			if (res.code == 200) {
				this.disciplineOptions = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		submitBtn(addOrDelTopicDialogTitle) {
			if (this.mulSelectVal.length > 0) {
				this.isSelect = this.mulSelectVal;
				let arrId = this.mulSelectVal.map(item => item.id).join(',');
				addSettingGroup({ review: arrId, id: this.workId, addOrDelTopicDialogTitle: addOrDelTopicDialogTitle }).then(res => {
					if (res.code == 200) {
						this.$message.success('操作成功');
						this.addOrDelTopicDialogVisible = false;
						this.isSelect = new Array();
						this.getSettingGroup();
					} else {
						this.$message.error(res.msg);
					}
				});
			} else {
				this.$message.warning('请勾选数据');
			}
		},
		// 打开课题列表
		openAddTopicDialog(type, item) {
			this.addTopicDialogForm.grade = 0;
			this.addTopicDialogForm.grade1 = null;
			if (type == 'view' || type == 'del') {
				if (item.review != null) {
					this.addTopicDialogForm.grade = item.review;
				}
			}
			if (type == 'add') {
				this.addTopicDialogForm.grade = null;
				if (this.review != null) {
					this.addTopicDialogForm.grade1 = this.review;
				}
			}
			this.workId = item.id;
			this.addOrDelTopicDialogVisible = true;
			this.addOrDelTopicDialogTitle = type == 'del' ? '移除作品' : type == 'add' ? '添加到评审组' : '查看作品';
			this.solicitateList();
			this.topicList.forEach(item1 => {
				this.isSelect.forEach(item2 => {
					if (item1.id == item2.id) {
						this.$refs.table2.toggleRowSelection(item1, true);
					}
				});
			});
		},
		// 课题表格多选
		mulSelectionChange(val) {
			this.mulSelectVal = val;
		},
		handleSizeChange(val) {
			this.addTopicDialogForm.pageSize = val;
			this.solicitateList();
		},
		handleCurrentChange(val) {
			this.addTopicDialogForm.pageNumber = val;
			this.solicitateList();
		},
		// 征文列表
		solicitateList() {
			getPageListReview(this.addTopicDialogForm).then(res => {
				if (res.code == 200) {
					this.topicList = res.data.records;
					this.topicTotal = res.data.total;
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		// 保存并下一步
		submitGroupForm() {
			this.$emit('finishBtn', 3);
		},
		// --------------------------分组-------------------------
		//添加或者删除课题分组
		openAddGroupDialog(type, item) {
			this.addGroupForm.name = item.name;
			this.rowId = item.id ? item.id : '';
			this.groupNameDialogShow = true;
		},
		//获取组
		getSettingGroup() {
			settingGroup(this.projectId).then(res => {
				this.groupList = res.data;
				if (res.data.length > 0) {
					this.review = res.data
						.filter(item => item.review)
						.map(item => item.review)
						.join(',');
				}
			});
		},
		// 添加或者修改分组
		addOrEditGroup() {
			this.$refs.addGroupFormRef.validate(valid => {
				if (valid) {
					addSettingGroup({ name: this.addGroupForm.name, projectManagementId: this.projectId, id: this.rowId }).then(res => {
						if (res.code == 200) {
							this.groupNameDialogShow = false;
							this.getSettingGroup();
						} else {
							this.$message.error(res.msg);
						}
					});
				}
			});
		},
		//删除组
		handleDelGroup(item) {
			delSettingGroup(item.id).then(res => {
				if (res.code == 200) {
					this.$message.success(res.msg);
					this.getSettingGroup();
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		// 取消修改组名
		cancelUpdateGroup() {
			this.addGroupForm.name = '';
			this.groupNameDialogShow = false;
		}
	}
};
</script>

<style scoped lang="scss">
.review {
}
</style>
